export default __webpack_public_path__ + "static/media/sky3.914d8e9b.jpg";